/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {BookmarkFormComponent as ɵc} from './bookmark-form/bookmark-form.component';
export {BookmarkComponent as ɵb} from './bookmark.component';
export {declaration as ɵa} from './bookmark.module';
export {BookmarkRoutes as ɵd} from './bookmark.routing';